import MuiLink from '@mui/material/Link';

interface Props {
  readonly phoneNumber?: string | null;
}

export const PhoneNumber = ({ phoneNumber }: Readonly<Props>) =>
  phoneNumber ? (
    <MuiLink color="secondary" href={`tel:${phoneNumber}`}>
      {phoneNumber}
    </MuiLink>
  ) : (
    <>Inconnu</>
  );
